<template>
	<div id="gycj">
		<VAccount></VAccount>
		<div style="height: 116px;"></div>
		<VBanner></VBanner>
		<!--主体内容开始-->
	<div class="content_box1">
		<div class="content_box2">
			<!--左侧菜单-->
			<div class="menu_box">
				<p class="menu_box_title">关于纯晶<span>About us</span></p>
				<ul class="menu_box1">
		          <li><a href="/gycj">公司简介</a></li>
		       </ul>
			</div>
			<!--右侧主体-->
		<div class="content_boxL">
		       <div class="content_boxL_nav">
		         <p class="content_boxL_nav_title">公司简介</p>
		         <div class="content_boxL_nav_R"><a href="">首页 &gt;</a> <a href="">关于纯晶 &gt;</a><a href=""> 公司简介</a></div>                          
		       </div>
		       <div class="content_boxL_text">
				<div class="xyxwnr_content" v-html="content"></div>
		       </div>
		<div class="clear"></div>
		</div>
		</div>
	</div>
	<VFooter></VFooter>
	</div>
</template>

<script>
import web from "@/assets/js/web.js"
import VAccount from '../subcomponents/account'
import VBanner from '../subcomponents/banner'
import VFooter from '../subcomponents/footer'
export default{
	components:{VAccount,VBanner,VFooter},
	data(){
		return{
		path: '/detail',    // 内容请求路径
        cfg: {params: {articleId:27}},    // 内容请求参数,this.$route.params.id 是内部路由传递过来的参数
        articleID: '',
        author: '',
        title: '',
        copyFrom: '',
        updateTime: '',
        content:'',
        hits: 0,
        filesUrl: [],    // 元素：{"fileTitle":"", "showUrl":"", "downloadUrl":""}, ...
		}
	},
	created(){
		this.getData();		
	},
	methods:{
		getData() {
        web.api.get(this.path, this.cfg).then(res=>{
          if(res.status) {
            this.articleID= res.data[0].articleID;
            this.author= res.data[0].author;
            this.title= res.data[0].title;
            this.copyFrom= res.data[0].copyFrom;
            this.updateTime= res.data[0].updateTime;
            this.content= res.data[0].content;
            this.hits= res.data[0].hits;
            this.filesUrl= res.data[0].fileUrl;
          }
          else console.log('出错信息:' + res.message);
        }).catch(error=>{console.log(error)});
      },
	},
}
</script>

<style scoped>
.content_box1 {
    width: 100%;
    position: relative;
    top:-40px;
    z-index: 595;
    left: 0;
}
.content_box2 {
    width: 1200px;
    overflow: hidden;
    margin: 0 auto;
    /*box-shadow: 0 0 6px #CCC;
	border: 1px solid white;*/
}
.menu_box {
    width: 207px;
    float: left;
}
.menu_box_title {
    width: 207px;
    height: 83px;
    color: white;
    font-size: 24px;
    text-align: center;
    padding-top: 20px;
    background:#419AD6;
}
.menu_box1 {
    width: 207px;
}
.menu_box1 li {
    width: 207px;
    height: 46px;
    font-size: 16px;
    margin: 2px 0;
    text-align: center;
    line-height: 46px;
}
.menu_box1 li a {
    color: #656565;
    display: block;
    background: #cacaca;
    width: 207px;
    height: 46px;
}
.menu_box_title span {
    display: block;
    font-size: 20px;
    color: #fff;
}
/*右侧*/
.content_boxL {
    width: 978px;
    float: right;
    overflow: hidden;
}
.content_boxL_nav {
    width: 978px;
    height: 56px;
    line-height: 56px;
    margin-top: 47px;
    overflow: hidden;
    border-bottom: 1px solid #cacaca;
}
.content_boxL_nav_title {
    float: left;
    font-size: 18px;
    color: #363636;
}
.content_boxL_nav_R {
    float: right;
}
.content_boxL_nav_R a {
    color: #363636;
}
.content_boxL_text {
    width: 945px;
    margin: 0 auto 80px;
}
.content_boxL_text p {
    text-indent: 2em;
    font: 14px/24px "微软雅黑";
    color: #666666;
    margin: 30px 0;
}
.clear {
    clear: both;
}
.menu_box1 li a:hover {
    background:#419AD6;
    color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/gycj/gycj.vue